import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row, View } from '@amzn/stencil-react-components/layout';
import { Input, InputWrapper } from '@amzn/stencil-react-components/input';
import { Select } from '@amzn/stencil-react-components/select';
import { Label, H4, Text } from '@amzn/stencil-react-components/text';
import { Checkbox } from '@amzn/stencil-react-components/checkbox';
import { Spacer } from '@amzn/stencil-react-components/layout';
import { FormattedMessage } from 'react-intl';
import {
  LEADER_LEVEL_INFO,
  LEADER_NAME_INFO,
  SegmentFilters,
} from '../../../constants/createSegment';
import { withTooltip } from '@amzn/stencil-react-components/tooltip';
import { ENTER_KEY } from '../../../constants/attributes';
// import { Tag } from '@amzn/stencil-react-components/tag';
import { Chip } from '@amzn/stencil-react-components/chip';

import {
  updateDirectReportsFilter,
  updateLeaderLevel,
  updateLeaderLogins,
} from '../../../actions/ruleFiltersActions';
import cloneDeep from 'lodash/cloneDeep';
import {
  activeRuleFiltersSelector,
  initialDataSelector,
  ruleFilterLeaderLevelLogin,
  ruleFilterLeaderLevelSelector,
  ruleFiltersSelector,
} from '../../../selectors/selectors';
import { updateJobLevels } from '../../../actions/initializeDataActions';

import { IconInformationSmall } from '@amzn/stencil-react-icons';

const IconWithTooltip = withTooltip()(IconInformationSmall);
const LeaderLevelFilter = () => {
  const dispatch = useDispatch();
  const { isDirectReport } = useSelector(ruleFiltersSelector);
  const leaderJobLevel = useSelector(ruleFilterLeaderLevelSelector);
  const leaderLogins = useSelector(ruleFilterLeaderLevelLogin);
  const activeFilters = useSelector(activeRuleFiltersSelector);
  const { jobLevels } = useSelector(initialDataSelector);

  const [isDisabled, setIsDisabled] = useState(
    !activeFilters?.includes(SegmentFilters.LEADER_FILTER),
  );

  const [leaderName, setLeaderName] = useState('');

  useEffect(() => {
    dispatch(updateJobLevels());
  }, []);

  const onLeaderAliasChange = e => {
    if (e.key === ENTER_KEY) {
      const logins = cloneDeep(leaderLogins);
      if (logins.indexOf(leaderName?.toLowerCase()) == -1 && leaderName?.trim() != '') {
        logins.push(leaderName);
        dispatch(updateLeaderLogins(logins));
      }
    }
  };

  const removeLogin = e => {
    const logins = leaderLogins;
    const filteredLogins = logins?.filter(login => login !== e);
    dispatch(updateLeaderLogins(filteredLogins));
  };

  const onLeaderLevelChange = e => {
    dispatch(updateLeaderLevel(e));
  };

  const onDirectReporteeChange = e => {
    dispatch(updateDirectReportsFilter(e.target?.checked));
  };
  return (
    <>
      <Row gridGap="S100">
        <Checkbox data-testid="rule-filter-1" checked={!isDisabled} />
        <Label fontSize={'T300'} display="flex" htmlFor="rule-filter-1" id="rule-filter-label1">
          <Text style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
            <FormattedMessage id="app.ruleFilter.label.leaderLevel" defaultMessage="LeaderLevel" />
          </Text>
          <Text fontSize={'T100'} style={{ fontWeight: 'bolder' }} color="primary">
            *
          </Text>
          <IconWithTooltip title="Leader Level" tooltipText={LEADER_LEVEL_INFO} color="primary70" />
        </Label>
      </Row>
      <Row gridGap="S100">
        <Col width={'10%'}>
          <InputWrapper labelText="" id="leaderjobLevel-condition">
            {inputProps => (
              <Select disabled={isDisabled} options={['Equals']} {...inputProps} value={'Equals'} />
            )}
          </InputWrapper>
        </Col>
        <Col width={'50%'}>
          <InputWrapper labelText="" id="leaderJobLevel">
            {inputProps => (
              <Select
                data-testid="leader-job-level"
                disabled={isDisabled}
                options={jobLevels}
                {...inputProps}
                value={leaderJobLevel}
                onChange={e => {
                  onLeaderLevelChange(e);
                }}
              />
            )}
          </InputWrapper>
        </Col>
      </Row>
      <Spacer height={32} />
      <Row gridGap="S100">
        <Label fontSize={'T300'} display="flex" htmlFor="rule-filter-2" id="rule-filter-label2">
          <Text style={{ justifyContent: 'center', alignItems: 'center', display: 'flex' }}>
            <FormattedMessage id="app.ruleFilter.label.leaderName" defaultMessage="Leader Alias" />
          </Text>
          <Text fontSize={'T100'} style={{ fontWeight: 'bolder' }} color="primary">
            *
          </Text>
          <IconWithTooltip title="Leader Name" tooltipText={LEADER_NAME_INFO} color="primary70" />
        </Label>
      </Row>
      <Row>
        <Col width={'60%'}>
          <InputWrapper id="leaderLogins" footer="Name of the leaders and then press enter">
            {inputProps => (
              <Input
                data-testid="leader-alias"
                disabled={isDisabled}
                onChange={e => {
                  setLeaderName(e.target.value);
                }}
                onKeyDown={onLeaderAliasChange}
                value={leaderName}
                placeholder="E.g. alias"
                {...inputProps}
              />
            )}
          </InputWrapper>
        </Col>
      </Row>
      <Row gridGap="S200" margin={'10px'} flexWrap="wrap">
        {leaderLogins?.map(login => (
          <Chip
            key={login}
            data-testid={`tag-${login}`}
            onDismiss={e => {
              removeLogin(login);
            }}
          >
            {login}
          </Chip>
        ))}
      </Row>
      <Row>
        <Col width="60%">
          <Spacer height={32} />
          <View display="flex" alignItems="center">
            <Checkbox
              disabled={isDisabled}
              id="direct-reports"
              data-testid="direct-report-option"
              checked={isDirectReport}
              onChange={e => onDirectReporteeChange(e)}
            />
            <Spacer width={10} />
            <Label htmlFor="direct-reports">
              <FormattedMessage
                id="app.createSegment.label.directReports"
                defaultMessage="Direct reports only?"
              />
            </Label>
          </View>
        </Col>
      </Row>
    </>
  );
};

export default LeaderLevelFilter;
